import { createRoutine } from 'redux-saga-routines';

// fetch
export const fetchAllPlaybookTemplates = createRoutine(
  'FETCH_ALL_PLAYBOOK_TEMPLATES'
);
export const fetchPlaybookTemplateById = createRoutine(
  'FETCH_PLAYBOOK_TEMPLATE_BY_ID'
);
export const fetchPlaybookTemplateChangelog = createRoutine(
  'FETCH_PLAYBOOK_TEMPLATE_CHANGELOG'
);
export const fetchPlaybookTaskTemplateChangelog = createRoutine(
  'FETCH_PLAYBOOK_TASK_TEMPLATE_CHANGELOG'
);

// add/edit
export const createPlaybookTemplate = createRoutine('CREATE_PLAYBOOK_TEMPLATE');
export const editPlaybookTemplate = createRoutine('EDIT_PLAYBOOK_TEMPLATE');
export const applyPlaybookTemplate = createRoutine('APPLY_PLAYBOOK_TEMPLATE');

// actions
export const archivePlaybookTemplate = createRoutine(
  'ARCHIVE_PLAYBOOK_TEMPLATES'
);
export const setInactivePlaybookTemplate = createRoutine(
  'SET_INACTIVE_PLAYBOOK_TEMPLATE'
);
export const setActivePlaybookTemplate = createRoutine(
  'SET_ACTIVE_PLAYBOOK_TEMPLATE'
);

// other
export const showPlaybookTemplateAddEditForm = createRoutine(
  'SHOW_PLAYBOOK_TEMPLATE_ADD_EDIT_FORM'
);
